export default `
  mutation initGitHubRepo($login: String!, $owner: String!, $repo: String!, $branch: String!, $filePath: String!, $content: String!, $message: String!) {
    initGitHubRepo(login: $login, owner: $owner, repo: $repo, branch: $branch, filePath: $filePath, content: $content, message: $message) {
      success
      resData
      errorText
    }
  }
`
